import { useQuery } from 'react-query'
import { VersionAPI } from '../helpers'
import { getAPIVersion } from '../helpers/crud-helper/_request'

const API_VERSION_QUERY_KEY = 'api-versao'

export const useAPIVersion = () =>
  useQuery<VersionAPI>(API_VERSION_QUERY_KEY, getAPIVersion, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: false,
  })
